import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { clientsData, clientsDataUpdate, clientsDataInsert, clientsDataDelete, dataUpload, clientsDataPage } from './clientsActions'
import { ErrorResponse } from "src/types/error-response.type";
import { SuccessResponse } from "src/types/success-response.type";
import { ClientsResponse, ClientsResponseLength } from 'src/types/request.type';



type ClientsStatePage = {
  dataClientsPage: {
    payload: ClientsResponseLength | null,
    payload_update: ClientsResponse | null,
    loading: boolean,
    success: boolean,
    error: string | null;
  }
}


const initialState: ClientsStatePage = {
  dataClientsPage: {
    loading: false,
    success: false,
    payload_update: null,
    payload: null,
    error: "",
  }
}




const clientsSlicePage = createSlice({
  name: 'clientsPage',
  initialState: initialState,
  reducers: {

    // Обычные редьюсеры
    setClientsStatePage(state, action: PayloadAction<ClientsResponseLength>) { //ClientsResponse[]
      const stateNew = state;
      stateNew.dataClientsPage.payload =  {} as ClientsResponseLength; 
      stateNew.dataClientsPage.payload = action.payload;
      state = stateNew;
    
    },

    setClientUpdateStatePage(state, action: PayloadAction<ClientsResponse>) {
      const stateNew = state;
      stateNew.dataClientsPage.payload_update = null;
      stateNew.dataClientsPage.payload_update = action.payload;
      state = stateNew;

    }

  },


  extraReducers: (builder) => {
    builder
      .addCase(clientsDataPage.pending, (state) => {
        state.dataClientsPage.loading = true;
        state.dataClientsPage.error = null;
      })
      .addCase(clientsDataPage.fulfilled, (state, action) => {
        state.dataClientsPage.loading = false;
        clientsSlicePage.caseReducers.setClientsStatePage(state, action);
      })
      .addCase(clientsDataPage.rejected, (state, action) => {
        state.dataClientsPage.loading = false;
        const errorText = getErrorText(action.payload as ErrorResponse);
        state.dataClientsPage.error = errorText ? errorText : "";
      })

  }

})


const getErrorText = (error: ErrorResponse) => {

 // console.log(error);

  switch (error?.error) {
    case "invalid0":
      return "invalid0";
    case "invalid1":
      return "invalid1";
    default:
      return "";
  }
}


export default clientsSlicePage.reducer